import { useEffect } from "react";
import { useParams } from "react-router-dom";

export const HSForms = () => {
    const { formid } = useParams()
    const formNames = {
        "08f272f8-3a4d-489a-b3e8-568a253d9995": "Speaker",
        "c1f17572-8594-4a15-b7ba-9b0ea03a0642": "Judge"
    }
    const formName = `${formNames[formid] || ''}`
    document.title = `youngStartup Ventures | ${formName} Form`;
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "//js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);
        script.addEventListener("load", () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: "536350",
                    formId: formid,
                    target: "#HSForm",
                });
            }
        });
    });

    return (
        <div style={{ padding: '2em', width: '90%', margin: '6em auto 2em auto', maxWidth: '800px', border: '1px solid black', borderRadius: '10px' }}>
            <div
                id="HSForm"
            />
        </div>
    );
};
